// TODO: make cast queries to array and rename method to isQueryFetching
export const isAnyQueryFetching = (queries) => queries.some((query) => query.isFetching);

// TODO: make cast queries to array and rename method to getQueryError
export const getAnyQueryError = (queries, { findQuery = ({ error }) => error } = {}) => {
  const queryWithError = queries.find(findQuery);

  return queryWithError?.error ?? null;
};

export const withUpdateForm = ({ form, field, ...queryConfig }) => ({
  onSuccess: (...args) => {
    const [data] = args;
    form.setFieldsValue({ [field.name]: data });

    // eslint-disable-next-line no-unused-expressions
    queryConfig?.onSuccess?.(...args);
  },
});

export const withOnSuccess = (queryConfig, onSuccess) => ({
  ...queryConfig,
  onSuccess: (...args) => {
    onSuccess(...args);
    // eslint-disable-next-line no-unused-expressions
    queryConfig?.onSuccess?.(...args);
  },
});

export const withOnSuccessFp = (onSuccess) => (queryConfig) => withOnSuccess(queryConfig, onSuccess);

export const withOnError = (queryConfig, onError) => ({
  ...queryConfig,
  onError: (...args) => {
    onError(...args);
    // eslint-disable-next-line no-unused-expressions
    queryConfig?.onError?.(...args);
  },
});

export const withOnErrorFp = (onSuccess) => (queryConfig) => withOnError(queryConfig, onSuccess);
